(() => {
  const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-filter-search]')) return;
    const group = event.target.closest('[data-filter-options]');
    const query = normalise(event.target.value);
    let visible = 0;
    group.querySelectorAll('[data-filter-value]').forEach(label => {
      const matches = normalise(label.dataset.filterValue).includes(query);
      label.hidden = !matches;
      if (matches) visible++;
    });
    group.querySelector('[data-filter-no-match]').hidden = visible > 0;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('.discovery-toolbar .filters-panel[open]');
    if (!panel) return;
    panel.open = false;
    panel.querySelector('summary').focus();
  });
})();
